import { request } from "../base";

export type ConsultationBookingStatus =
	| "pending"
	| "contacted"
	| "completed"
	| "cancelled";

export type ConsultationBooking = {
	id: number;
	reference: string;
	phone: string;
	details: string | null;
	status: ConsultationBookingStatus;
	homeownerId: string | null;
	sourcePage: string | null;
	dateCreated: string;
	dateUpdated: string;
};

export const adminConsultationsApi = {
	listConsultations(filters?: {
		page?: number;
		limit?: number;
		status?: ConsultationBookingStatus;
	}) {
		const params = new URLSearchParams();
		if (filters?.page) params.set("page", String(filters.page));
		if (filters?.limit) params.set("limit", String(filters.limit));
		if (filters?.status) params.set("status", filters.status);
		const qs = params.toString();
		return request<ConsultationBooking[]>(
			`/api/admin/consultations${qs ? `?${qs}` : ""}`,
		);
	},

	updateConsultationStatus(id: number, status: ConsultationBookingStatus) {
		return request<ConsultationBooking>(`/api/admin/consultations/${id}`, {
			method: "PATCH",
			body: { status },
		});
	},
};
